import { render } from "./TabButton.vue?vue&type=template&id=05ddb99a&scoped=true"
import script from "./TabButton.vue?vue&type=script&lang=js"
export * from "./TabButton.vue?vue&type=script&lang=js"

import "./TabButton.vue?vue&type=style&index=0&id=05ddb99a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1770878715/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ddb99a"]])

export default __exports__